<template>
    <v-flex>
        <v-layout
            row
            wrap
            class="relative-position">
            <v-flex id="file-drag-drop">
                <div>
                    <v-flex pa-3 v-if="value.length > 0">
                        <v-layout row class="drop-area__row">
                            <v-flex
                                v-for="(file, i) in value"
                                :key="i"
                                class="displayImage__profileImage">
                                <v-flex class="file-icons">
                                    <i large :class="iconClassNames(file.type)" class="icon-field">
                                        <em class="fa fa-times-circle close-btn" :data-qe-id="`file-${i}_remove_btn`" @click="removeFile(i)"></em>
                                    </i>
                                    <span class="file-name" :title="file.name" :data-qe-id="`file-${i}_name`">
                                        {{file.name}}
                                    </span>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <form v-else
                        :class="[displayNewVideoUploadWarning && !uploadVideoWarningAccepted ? 'video-overlay-new': '']"
                        @click="openUploadWarningPopup(false)"
                        ref="fileform"
                        v-on:drag.stop.prevent
                        v-on:dragstart.stop.prevent
                        v-on:dragend.stop.prevent
                        v-on:dragover.stop.prevent
                        v-on:dragenter.stop.prevent
                        v-on:dragleave.stop.prevent
                        v-on:drop.stop.prevent="onDropFiles"
                        class="drop-area">
                        <v-layout row wrap>
                            <v-flex
                                :class="[value.length > 0 ? xs4 : xs12]"
                                class="file-select-btn">
                                <v-flex>
                                    <file-upload
                                        class="card__file-upload"
                                        v-model="addedFiles"
                                        ref="fileUploadVideo"
                                        id="file-upload-video"
                                        input-id="`file_upload_video`"
                                        data-qe-id="`file_upload_video`">
                                        <v-flex class="relative-position">
                                            <i class="fas fa-cloud-upload-alt"></i>
                                            <i class="fas fa-video"></i>
                                        </v-flex>
                                        <v-flex class="drop-files">
                                            <strong>{{uploadVideoLabel || speakerRegistrationConstants.UPLOAD_A_VIDEO_PRESENTATION}}</strong>
                                        </v-flex>
                                    </file-upload>
                                    <v-flex class="upload-info">
                                        <small class="drop-files">{{speakerRegistrationConstants.VIDEO_MUST_NOT_EXCEED}}</small>
                                        <small>{{speakerRegistrationConstants.VIDEO_TYPES_SUPPORTED_MESSAGE}}</small>
                                    </v-flex>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </form>
                </div>
            </v-flex>
        </v-layout>
        <v-flex pb-4 v-if="errorMessage.length > 0">
            <span class="error-message">{{errorMessage}}</span>
        </v-flex>
        <v-dialog v-model="showNewVideoUploadWarning" width="500">
            <v-card class="new-video-dialog">
                <v-card-title>
                    {{speakerValidationConstants.UPLOAD}}
                    <i class="fas fa-times" data-qe-id="cancel_dialog_btn" @click="showNewVideoUploadWarning = false"></i>
                </v-card-title>
                <v-card-text pt-2 pb-2>
                    {{speakerValidationConstants.NEW_VIDEO_UPLOAD_CONFIRMATION}}
                </v-card-text>
                <v-card-actions class="align-center" @click="acceptVideoWarning()">
                    <file-upload v-if="!videoWarningOnDragDrop"
                        class="card__file-upload"
                        v-model="addedFiles"
                        ref="newFileUploadVideo"
                        input-id="`file_upload_video`"
                        data-qe-id="`file_upload_video`">
                        <v-btn
                            flat
                            class="primary_btn"
                            data-qe-id="choose-another-video_btn">
                            {{speakerValidationConstants.UPLOAD}}
                        </v-btn>
                    </file-upload>
                    <v-btn v-else
                        flat
                        class="primary_btn"
                        data-qe-id="choose-another-video_btn">
                        {{speakerValidationConstants.UPLOAD}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>


<script>
    import { speakerRegistrationConstants, speakerValidationConstants } from "./speakerConstant";
    import { communityCommonConstant, iconClassNames } from "../ChapterPage/communityCommon.constant";
    import FileUpload from "vue-upload-component";
    import 'vue-croppa/dist/vue-croppa.css';

    export default {
        name: 'DragAndDropPhoto',
        data() {
            return {
                xs4: 'xs4',
                xs12: 'xs12',
                errorMessage: '',
                commonConstant: communityCommonConstant,
                speakerRegistrationConstants,
                speakerValidationConstants,
                addedFiles: [],
                timeOutSeconds: communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS,
                maxFileSize: 500,
                maxVideosAccepted: 1,
                fileName: '',
                showNewVideoUploadWarning: false,
                uploadVideoWarningAccepted: false,
                videoWarningOnDragDrop: false,
            };
        },
        props: {
            value: {
                type: Array,
                required: true,
            },
            videoTypesSupported: {
                type: Array,
                required: true,
            },
            uploadVideoLabel: {
                type: String,
            },
            displayNewVideoUploadWarning: {
                type: Boolean,
            },
        },
        watch: {
            addedFiles(files) {
                if (files.length) {
                    this.showNewVideoUploadWarning = false;
                    this.addFiles(files.map(v => v.file));
                    this.addedFiles = [];
                }
            },
        },
        components: {
            FileUpload,
        },
        methods: {
            onDropFiles(e) {
                if (!this.openUploadWarningPopup(true)) {
                    this.addFiles(e.dataTransfer.files);
                }
            },
            acceptVideoWarning() {
                this.showNewVideoUploadWarning = false;
                this.uploadVideoWarningAccepted = true;
            },
            addFiles(selectedFiles) {
                for (let i = 0; i < selectedFiles.length; i += 1) {
                    if (this.validateVideo(selectedFiles[i])) {
                        this.value.push(selectedFiles[i]);
                        this.fileName = selectedFiles[i].name;
                    }
                }
            },
            validateVideo(videoFile) {
                let isValidVideo = true;
                if (this.value.length === this.maxVideosAccepted) {
                    isValidVideo = false;
                } else if (!(new RegExp(this.videoTypesSupported.join("|")).test(videoFile.name.toLowerCase()))) {
                    this.errorMessage = this.commonConstant.filesAndMedia.FILE_NOT_SUPPORTED;
                    isValidVideo = false;
                } else if (videoFile.name.split('.')[0].length > 200) {
                    this.errorMessage = this.commonConstant.filesAndMedia.FILE_NAME_LENGTH_EXCEEDED;
                    isValidVideo = false;
                } else if (videoFile.size / (1024 * 1024) >= this.maxFileSize) {
                    this.errorMessage = speakerValidationConstants.VIDEO_SIZE;
                    isValidVideo = false;
                }
                setTimeout(() => { this.errorMessage = ''; }, this.commonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                return isValidVideo;
            },
            removeFile(key) {
                this.value.splice(key, 1);
            },
            openUploadWarningPopup(onDropFile) {
                if (this.displayNewVideoUploadWarning && !this.uploadVideoWarningAccepted) {
                    this.showNewVideoUploadWarning = true;
                    this.videoWarningOnDragDrop = onDropFile;
                    this.$refs.fileUploadVideo.upload = false;
                    return true;
                }
                return false;
            },
            iconClassNames,
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";
    $control-height: 100px;
    $marginTop-progress: $control-height - 85px;
    $dragdrop_background: $ypo-extra-light-gray;
    $dragdrop_background_mian: $white;
    $dorder_dash_color: $ypo-light-medium-gray;
    $image_icon_color:$ypo-duskblue;

    .video-overlay-new {
        position: relative;

        &::after {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 2;
            content: "";
            top: 0;
            left: 0;
        }
    }

    .speakers-steps {
        .registration-page {
            &__drag-photo {
                &.registration-page__drag-photo__error {
                    #file-drag-drop {
                        .drop-area {
                            border: 1px solid $ypo-error-red;
                        }
                    }

                }

                .displayImage {
                    position: relative;

                    &__profileImage {
                        position: absolute;
                        left: 15px;
                        top: 15px;

                        figure {
                            width: 175px;
                            height: 135px;
                            text-align: center;
                            border: 2px solid $ypo-open-blue-gray;
                            position: relative;

                            .v-btn {
                                background: $ypo-cta !important;
                                color: $white;
                                bottom: 0;
                                cursor: pointer;
                                right: 0;
                                font-weight: 600;
                                padding: 10px 27px 60px;
                                margin: 0;
                                overflow: hidden;
                                width: 100%;
                                top: 75px;
                                position: absolute;

                                i {
                                    display: block;
                                    font-size: 24px;
                                    margin-top: 5px;
                                }

                                &__content {
                                    display: initial !important;
                                }
                            }
                        }

                        .file-name {
                            font-size: 14px;
                            color: $ypo-blue;
                            margin-top: 5px;
                            display: block;
                            font-weight: 600;
                        }
                    }
                }

            }

            &__upload-video {
                &.registration-page__upload-video__error {
                    #file-drag-drop {
                        .drop-area {
                            border: 1px solid $ypo-error-red;
                        }
                    }
                }

            }

           

            .croppa-container {
                background-color: $ypo-medium-gray;
                padding: 0px;
                width: 100%;
                height: 100%;

                &:hover {
                    opacity: 1;
                }

                canvas {
                    position: relative;
                    border: 2px dashed #333;

                    &:hover {
                        opacity: 0.5;
                    }
                }

                &.croppa--has-target {

                    canvas {
                        border: none;

                        &:hover {
                            opacity: 1;
                        }
                    }
                }
            }

            .slider {
                -webkit-appearance: none;
                width: 100%;
                height: 3px;
                background: $ypo-gray;
                outline: none;
                opacity: 0.7;
                -webkit-transition: .2s;
                transition: opacity .2s;
                border-radius: 50px;
            }

            .slider:hover {
                opacity: 1;
            }

            .slider::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 20px;
                height: 20px;
                background: $ypo-blue;
                cursor: pointer;
                border-radius: 50px;
            }

            .slider::-moz-range-thumb {
                width: 20px;
                height: 20px;
                background: $ypo-blue;
                cursor: pointer;
            }

        }
    }
    .video-uploader {
     #file-drag-drop {
                background-color: transparent;

                .drop-area {
                    border: 0;
                    background-color: transparent;
                    padding: 0;
                    margin: 0;
                    text-align: center;
                    align-items: center;
                    display: flex;

                    &__row {
                        max-width: 100%;
                        overflow-x: auto;
                    }

                    .file-select-btn {
                        padding-top: 0;
                    }

                }

                .file-icons {
                    padding: 5px 0;
                    margin: 0 15px;
                    max-width: 160px;
                    text-align: center;

                    span {
                        color: $image_icon_color !important;
                        margin-top: 5px;
                        display: block;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    i {
                        font-size: 40px;
                        color: $image_icon_color;
                        position: relative;
                    }

                    em {
                        position: absolute;
                        top: -5px;
                        right: -23px;
                        font-size: 18px;
                        cursor: pointer;
                        color: $image_icon_color;
                    }

                    .v-responsive__content {
                        &:hover {
                            background-color: rgba($black, 0.6);
                            align-items: center;
                            display: flex;
                            justify-content: center;

                            .photo-review__remove-btn {
                                opacity: 1;
                                visibility: visible;
                            }
                        }
                    }
                }

                .file-select-btn {
                    span {
                        display: block;

                        label {
                            cursor: pointer;
                        }
                    }
                }

                .upload-progress-area {
                    .icon-field {
                        margin-left: -5px;
                        color: $ypo-duskblue
                    }

                    span {
                        color: $ypo-duskblue;
                    }
                }

                .progress {
                    appearance: none;
                    padding: 0;
                    border: none;
                    border-radius: 0;
                    display: block;
                    color: $ypo-duskblue;
                    width: 250px;
                    height: 5px;
                    margin-top: $marginTop-progress;
                }

                /* Chrome */
                progress::-webkit-progress-bar {
                    background-color: $ypo-light-gray;
                }

                progress::-moz-progress-bar {
                    background-color: $ypo-light-gray;
                }

                progress::-webkit-progress-value {
                    background-color: $ypo-duskblue;
                }

            }
        }

    .speakers-db-upload {
        &__upload-photo {
            text-align: center;
            padding: 0;
            margin-right: 0px !important;
            background-color: $ypo-medium-gray;

            i {
                font-size: 20px;
                color: $ypo-medium-gray;
            }

            .rotate_btn {

                label {
                    padding: 5px;
                }
            }

        }

        &__action-items {
            padding: 13px 0 10px 12px;
            margin-top: 1px;

            .fa-user {
                font-size: 12px;
                color: $ypo-blue;
                background: $white;
                width: 20px;
                border-radius: 50%;
                height: 20px;
                text-align: center;
                line-height: 20px;
            }

            span {
                margin-left: 30px;
                color: $ypo_blue;

                i {
                    font-size: 14px;
                    color: $ypo_blue;
                }

                button:focus {
                    outline: none;
                }
            }

            input[type=range] {
                width: 175px;
                margin: 0 5px;
                position: relative;
                top: -2px;

                &+i {
                    width: 26px;
                    height: 26px;
                    font-size: 16px;
                    line-height: 24px;
                }

                @include breakpoint(sm) {
                    width: 130px;
                }
            }

            @include breakpoint(xs) {
                span {
                    margin-left: 0;
                }
            }
        }
    }

    .new-video-confirmation-wrapper {
        position: relative;
        height: 100%;
        width: 100%;
        z-index: 1;
        cursor: pointer;

    }

    .new-video-dialog {
        .v-card__title {
            background-color: $ypo-tile-border;
            color: $ypo-blue;
            font-family: Raleway, sans-serif;
            font-size: 20px;
            font-weight: 500;
            line-height: 20px;
            position: relative;

            i {
                color: $ypo-cta;
                position: absolute;
                font-size: 16px;
                right: 20px;
                cursor: pointer;
            }
        }

        .v-card__text {
            font-size: 14px;
        }

        .v-card__actions {
            padding-bottom: 15px !important;
            justify-content: center;

            span.card__file-upload {
                margin: 0 auto;
            }

            .file-uploads {
                label {
                    cursor: pointer;
                }
            }
        }
    }
</style>
